import { gql } from "@apollo/client";

const CUSTOMIZE_FONT = gql`
  mutation customizeFont($input: getFont!) {
    customizeFont(input: $input) {
      status
      data
      error
    }
  }
`;

export default CUSTOMIZE_FONT;
